import loadable from "@loadable/component";
import { CmsPaginate, NoSsr, useStores } from "@metablock/react";
import React from "react";
import { Route, Routes } from "react-router-dom";
import { useAsync } from "react-use";
import docs from "../content/docs/collection.json";
import { DocsList } from "./Public/Docs";
import Public from "./Public/Index";

const Private = loadable(
  () => import(/* webpackChunkName: "private" */ "./Private/Index")
);

const App = () => {
  return (
    <NoSsr>
      <Private />
    </NoSsr>
  );
};

const Main = () => {
  const { commonStore, userStore } = useStores();

  useAsync(async () => {
    if (commonStore.token) await userStore.getUser();
    commonStore.setAppLoaded();
  });

  if (commonStore.appLoaded) {
    return (
      <Routes>
        <Route
          path="/docs/*"
          element={
            <CmsPaginate
              topic="docs"
              path="/docs"
              slug={docs.slug}
              Component={DocsList}
            />
          }
        />
        <Route path="/app/*" element={<App />} />
        <Route path="/*" element={<Public />} />
      </Routes>
    );
  } else {
    return null;
  }
};

export default Main;
